import { createReducer, on, Action } from '@ngrx/store';

import { EventFrom } from '../COMMON/models/analytics-common.models';
import { GA4AnalyticsPublicActions } from '../GA4/public.api';
import { AnalyticsCategory } from '../services/analytics.constants';

import {
    LoadEventSuccess,
    UniversalPageViewIsSent,
    MarkReferredSent,
} from './analytics.actions';
import { analyticsInitialState, AnalyticsState } from './analytics.state';
import { ClickProductoBuscadorAnalytics, LastSizesProductClickAnalytics, RelatedProductClickAnalytics, ProductClickAnalytics, SetFirstMessageTriggerAnalytics } from './app-events-analytics.actions';

import { SetPage } from '@core/infrastructure/state/core-commands.actions';
import { ClearProductPage } from '@pages/product/store/product-page.actions';

/**
 * Definicion de las acciones que implementa el "userReducer"
 */
const analyticsReducerDefinition = createReducer(
    analyticsInitialState,

    on(LoadEventSuccess, (state: AnalyticsState, { payload }): any => {
        return {
            ...state,
            events: [
                ...state.events,
                payload,
            ],
        };
    }),
    on(SetFirstMessageTriggerAnalytics, (state: AnalyticsState, { pending }): AnalyticsState => {
        return {
            ...state,
            universal: {
                ...state.universal,
                chat: {
                    ...state.universal.chat,
                    firstMessagePendingToBeSent: pending,
                },
            },

        };
    }),
    on(RelatedProductClickAnalytics, (state: AnalyticsState, payload): AnalyticsState => {
        const origin = payload?.data?.place === 'SEARCH';
        const parent = payload.data.parentType || 'default';
        const searchOrigin = origin ? { eventFrom: EventFrom.search, origin: parent } : null;
        return {
            ...state,
            related: {
                type: payload?.data?.parentType,
            },
            typePhoto: payload?.data?.extraData?.typePhoto,
            searchOrigin,
        };
    }),

    on(LastSizesProductClickAnalytics, (state: AnalyticsState, payload): AnalyticsState => {
        return {
            ...state,
            fromLastSizesType: payload?.data?.product?.type,
            typePhoto: payload?.data?.extraData?.typePhoto,
        };
    }),

    on(ClearProductPage, (state: AnalyticsState): AnalyticsState => {
        return {
            ...state,
            related: null,
            fromLastSizesType: null,
            searchOrigin: null,
        };
    }),
    on(ClickProductoBuscadorAnalytics, (state: AnalyticsState, payload): AnalyticsState => {
        return {
            ...state,
            searchOrigin: payload,
        };
    }),
    on(ProductClickAnalytics, (state: AnalyticsState, payload): AnalyticsState => {
        const origin = payload?.data?.category === AnalyticsCategory.search;
        const searchOrigin = origin ? { eventFrom: EventFrom.search, origin: 'default' } : null;
        return {
            ...state,
            typePhoto: payload?.data?.extraData?.typePhoto,
            searchOrigin,
        };
    }),
    on(SetPage, (state: AnalyticsState): AnalyticsState => {
        return {
            ...state,
            ga4: {
                ...state.ga4,
                pageviewSent: false,
            },
            universal: {
                ...state.universal,
                pageviewSent: false,
            },
        };
    }),

    on(GA4AnalyticsPublicActions.Ga4SetPageviewSent, (state: AnalyticsState, { isSent }): AnalyticsState => {
        return {
            ...state,
            ga4: {
                ...state.ga4,
                pageviewSent: isSent,
            },
        };
    }),

    on(UniversalPageViewIsSent, (state: AnalyticsState, { isSent }): AnalyticsState => {
        return {
            ...state,
            universal: {
                ...state.universal,
                pageviewSent: isSent,
            },
        };
    }),

    on(MarkReferredSent, (state: AnalyticsState): AnalyticsState => {
        return {
            ...state,
            referredSent: true,
        };
    }),

);

/**
 * Reducer para el usuario actual
 */
export function analitycsReducer(state: AnalyticsState, action: Action): AnalyticsState {
    return analyticsReducerDefinition(state, action);
}
